import React from "react";
import { useLocation } from "react-router-dom";

import {
  Facebook,
  Instagram,
  YouTube,
  LinkedIn,
  BusinessSharp,
  Assignment,
  LocationOn,
  Phone,
  Email,
  Language,
  ArrowOutward,
} from "@mui/icons-material";

import { Link as RouterLink } from "react-router-dom";

import "./Footer.css";

const Footer = () => {
  const location = useLocation();

  const currentYear = new Date().getFullYear();

  const isActive = (path) => location.pathname === path;

  return (
    <footer className="farmology-footer">
      <div className="footer-container">
        {/* =====================================================
            FOUR COLUMN FOOTER
        ====================================================== */}

        <div className="footer-main">
          {/* =================================================
              COLUMN 1 — LOGO / ABOUT
          ================================================== */}

          <div className="footer-column footer-brand">
            <RouterLink to="/" className="footer-logo-link">
              <img
                src="/LOGOS/Farmology-Logo-e1687720251448.png"
                alt="Farmology"
                className="footer-logo"
              />
            </RouterLink>

            <span className="footer-eyebrow">
              <span></span>
              SMART AGRICULTURE
            </span>

            <h2>
              Better decisions.
              <br />
              <span>Better farming.</span>
            </h2>

            <p className="footer-description">
              Farmology is dedicated to empowering farmers through technology
              and sustainable practices. We provide unbiased crop advisory
              services, advanced crop health monitoring, soil insights and
              precise recommendations to help farmers make better decisions.
            </p>

            <p className="footer-description footer-description-small">
              Our vision is to build trust across the agricultural ecosystem and
              create a more sustainable future for everyone.
            </p>
          </div>

          {/* =================================================
              COLUMN 2 — COMPANY DETAILS
          ================================================== */}

          <div className="footer-column footer-company">
            <div className="footer-section-label">COMPANY</div>

            <h3>
              Who we
              <span> are.</span>
            </h3>

            <div className="footer-company-list">
              {/* Company */}
              <div className="footer-company-item">
                <div className="footer-contact-icon">
                  <BusinessSharp />
                </div>

                <div>
                  <span>Company</span>
                  <strong>Surobhi Agro Industries Pvt. Ltd.</strong>
                </div>
              </div>

              {/* GST */}
              <div className="footer-company-item">
                <div className="footer-contact-icon">
                  <Assignment />
                </div>

                <div>
                  <span>GST Number</span>
                  <strong>19ABBCS3198L1ZQ</strong>
                </div>
              </div>

              {/* CIN */}
              <div className="footer-company-item">
                <div className="footer-contact-icon">
                  <Assignment />
                </div>

                <div>
                  <span>CIN</span>
                  <strong>U01100WB2018PTC229465</strong>
                </div>
              </div>

              {/* Corporate Office */}
              <div className="footer-company-item footer-address-item">
                <div className="footer-contact-icon">
                  <LocationOn />
                </div>

                <div>
                  <span>Corporate Office</span>

                  <strong>
                    Surobhi Agro Industries Private Limited
                    <br />
                    East India Coworking — Eden, 2nd Floor
                    <br />
                    Hanuman Estates, 19 RN Mukherjee Rd
                    <br />
                    Esplanade, Lal Bazar, Kolkata
                    <br />
                    West Bengal 700001
                  </strong>

                  <a
                    href="https://maps.app.goo.gl/TyQGinpuEo52Tae26"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-map-link"
                  >
                    View on Map
                    <ArrowOutward />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              COLUMN 3 — QUICK LINKS
          ================================================== */}

          <div className="footer-column footer-navigation">
            <div className="footer-section-label">EXPLORE</div>

            <h3>
              Farmology
              <span> at a glance.</span>
            </h3>

            <nav className="footer-quick-links">
              <RouterLink
                to="/"
                className={isActive("/") ? "footer-link-active" : ""}
              >
                Home
                <ArrowOutward />
              </RouterLink>

              <RouterLink
                to="/service"
                className={isActive("/service") ? "footer-link-active" : ""}
              >
                Our Services
                <ArrowOutward />
              </RouterLink>

              <RouterLink
                to="/pricing"
                className={isActive("/pricing") ? "footer-link-active" : ""}
              >
                Pricing
                <ArrowOutward />
              </RouterLink>

              <RouterLink
                to="/demo-report"
                className={isActive("/demo-report") ? "footer-link-active" : ""}
              >
                Demo
                <ArrowOutward />
              </RouterLink>

              <RouterLink
                to="/contact"
                className={isActive("/contact") ? "footer-link-active" : ""}
              >
                Contact Us
                <ArrowOutward />
              </RouterLink>

              <a href="/sitemap.xml">
                Sitemap
                <ArrowOutward />
              </a>
            </nav>
          </div>

          {/* =================================================
              COLUMN 4 — CONTACT + FOLLOW US
          ================================================== */}

          <div className="footer-column footer-contact">
            <div className="footer-section-label">CONTACT</div>

            <h3>
              We&apos;re here
              <span> to help.</span>
            </h3>

            <div className="footer-contact-list">
              {/* Phone */}
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <Phone />
                </div>

                <div>
                  <span>Phone</span>

                  <a href="tel:+917044245566" className="footer-contact-link">
                    +91-7044245566
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <Email />
                </div>

                <div>
                  <span>Email</span>

                  <a
                    href="mailto:info@farmologyindia.com"
                    className="footer-contact-link"
                  >
                    info@farmologyindia.com
                  </a>
                </div>
              </div>

              {/* Website */}
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <Language />
                </div>

                <div>
                  <span>Website</span>

                  <a
                    href="https://www.farmology.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-contact-link"
                  >
                    www.farmology.ai
                  </a>
                </div>
              </div>
            </div>

            {/* =================================================
                FOLLOW US
            ================================================== */}

            <div className="footer-follow">
              <div className="footer-social-heading">FOLLOW US</div>

              <div className="footer-socials">
                <a
                  href="https://www.facebook.com/p/Farmology-100063893500354/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <Facebook />
                </a>

                <a
                  href="https://www.youtube.com/channel/UCgjha5OQ4B0pdntZGAncvaQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <YouTube />
                </a>

                <a
                  href="https://www.instagram.com/farmo_logy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <Instagram />
                </a>

                <a
                  href="https://in.linkedin.com/company/farmology-surobhi-agro"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <LinkedIn />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* =====================================================
            BOTTOM FOOTER
        ====================================================== */}

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <RouterLink
              to="/privacy-policy"
              className={
                isActive("/privacy-policy") ? "footer-policy-active" : ""
              }
            >
              Privacy Policy
            </RouterLink>

            <span></span>

            <RouterLink
              to="/terms-of-service"
              className={
                isActive("/terms-of-service") ? "footer-policy-active" : ""
              }
            >
              Terms of Service
            </RouterLink>

            <span></span>

            <RouterLink
              to="/refund-policy"
              className={
                isActive("/refund-policy") ? "footer-policy-active" : ""
              }
            >
              Refund Policy
            </RouterLink>
          </div>

          <div className="footer-bottom-right">
            © {currentYear} Surobhi Agro Industries Pvt. Ltd.
            <br className="footer-mobile-break" />
            All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
